import isEmpty from 'lodash.isempty';

/**
 * Get search query parameter from current URL.
 *
 * @return string
 */
export function getSearchQuery() {
  const url = new URL(window.location.href);
  return url.searchParams.get('q') || '';
}

/**
 * Create an Algolia filters strings, applying given
 * attribute to every value and stringing them with
 * given operator.
 *
 * @param string    attribute
 * @param string[]  values
 * @param string    operator
 *
 * @returns string  e.g. 'type:post AND type:page'
 */
export function createFilters(attribute, values, operator = 'OR') {
  if (isEmpty(values)) {
    return '';
  }

  return `(${values.map(value => `${attribute}:${value}`).join(` ${operator} `)})`;
}

/**
 * JSON parse given value. Return null
 * if failure.
 *
 * @param string value
 *
 * @return object
 */
export function jsonParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

/**
 * Compare given months.
 *
 * @param string first
 * @param string second
 *
 * @return > 0 for correct, < 0 for reverse
 */
export function compareMonths(first, second) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return months.indexOf(first.name) - months.indexOf(second.name);
}
/**
 * Apply constraints to given value. Return
 * min or max if value is under or over.
 *
 * @param {number} value
 * @param {number} min
 * @param {number} max
 *
 * @return {number}
 */
export function constrain(value, min, max) {
  const minimum = Math.max(value, min);
  return Math.min(minimum, max);
}
